import { Box, BoxProps } from 'reflexbox';
import styled from 'styled-components';

import { Skeleton } from './Skeleton';

const Container = styled(Box)`
	width: 100px;
	height: 6px;
	background: ${(props) => props.theme.colors.lightBlue};
	border-radius: 3px;
`;

const Fill = styled(Box)<{ completed?: boolean }>`
	height: 6px;
	background: ${(props) =>
		props.completed ? props.theme.colors.green : props.theme.colors.primary};
	border-radius: 3px;
`;

export const Progress = Skeleton(
	function Progress(props: BoxProps & { value: number }) {
		return (
			<Container {...props}>
				<Fill
					width={`${(props.value * 100).toFixed(0)}%`}
					completed={props.value.toFixed(2) === '1.00'}
				/>
			</Container>
		);
	},
	styled(Skeleton.Box)`
		width: 100px;
		height: 6px;
	`,
);
